module.exports = __webpack_public_path__ + "static/antd-card-grid-f80dc0f1d9d71897242a6739e04286c9.gif";